import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

import { of } from 'rxjs/observable/of';
import { catchError, tap } from 'rxjs/operators';
import { Subscription } from 'rxjs/Subscription';

import { MessageService } from 'primeng/components/common/messageservice';
import { isNullOrUndefined } from 'util';

import { AutenticacaoService } from '../autenticacao/autenticacao.service';
import { Procedimentos } from '../base/vo/procedimentos';
import { SituacoesETiposAnexoVO } from '../base/vo/situacoes-e-tipos-anexo';
import { DetalharGtoService } from '../gto-detalhes/gto-detalhes.service';
import { NovaGtoService } from '../nova-gto/nova-gto.service';
import { AnexarImagensService } from './anexar-imagens.service';


const INPUT_NAME_MESSAGE = 'Anexar Imagens';
const DOC_EXTENSIONS = ['DOC', 'DOCX'];
const PDF_EXTENSIONS = ['PDF'];
const IMG_EXTENSIONS = ['PNG', 'JPG', 'JPEG', 'GIF', 'BMP'];

@Component({
  selector: 'app-anexar-imagens',
  templateUrl: './anexar-imagens.component.html',
  styleUrls: ['./anexar-imagens.component.css']
})
export class AnexarImagensComponent implements OnInit, OnDestroy {

  private tipos = [];
  private situacoes = [];
  private tiposAutorizacao = [];
  private tipoXSituacao: any;
  private situacoesETiposAnexoVO: SituacoesETiposAnexoVO = new SituacoesETiposAnexoVO();
  private onlyAttachView = false;

  @Input() codigoBeneficiario: string;
  @Input() habilitarAnexarAlterarImagem = false;
  @Input() listaAnexos;
  @Input() numeroGTO: string;
  @Input() onlyModal = false;
  @Input() prestExecutanteCodigo: string;
  @Input() procedimento: Procedimentos;
  @Input() somenteGuia = false;
  @Input() subtitulo: string;
  @Input() titulo: string;

  @Output() isInvalid = new EventEmitter();
  @Output() attachErrorEmmiter = new EventEmitter<boolean>();

  @ViewChild('file') file: ElementRef;


  private anexoCarregado = false;
  private classeBtn = 'bt bt-gray';
  private inputValue = '';
  private st = false;
  private subscriptionAnexosChangeEvent: Subscription;
  private subscriptionIsEditingGto: Subscription;

  public display = false;
  public errorAnexos = false;
  public inputName = INPUT_NAME_MESSAGE;
  public uploading = false;

  constructor(
    private anexarImagensService: AnexarImagensService,
    private novaGtoService: NovaGtoService,
    private detalharGtoService: DetalharGtoService,
    private auth: AutenticacaoService,
    private messageService: MessageService
  ) {
    this.subscriptionIsEditingGto = this.detalharGtoService.isEditingGto.subscribe(value => {
      if (value) {
        if (!this.procedimento || this.procedimento.status.toUpperCase() !== 'CANCELADO') {
          this.buscarSituacoesETiposAnexoAutorizacaoVinculacao();
        }
      }
    });

    this.subscriptionAnexosChangeEvent = this.anexarImagensService.anexosChangeEvent.subscribe(value => {
      if (value) {
        this.verificaErrosComponente();
      }
    });
  }

  ngOnInit() {
    this.changeButtonAnexarName();
    this.changeIconAnexar();
    this.inputName = this.changeInputName();

    this.situacoesETiposAnexoVO.numeroGTO = this.numeroGTO;
    this.situacoesETiposAnexoVO.codigoBeneficiario = this.codigoBeneficiario;
    this.situacoesETiposAnexoVO.codigoPrestador = this.prestExecutanteCodigo;
    this.buscarSituacoesETipos();

    if (this.listaAnexos) {
      this.errorAnexos = !this.isValidAnexosIncluidos();
    }

    if (this.habilitarAnexarAlterarImagem) {
      this.buscarSituacoesETiposAnexoAutorizacaoVinculacao();
    }
  }

  ngOnDestroy() {
    this.subscriptionIsEditingGto.unsubscribe();
    this.subscriptionAnexosChangeEvent.unsubscribe();
  }

  buscarSituacoesETipos() {
    this.anexarImagensService.buscarSituacoesETiposAnexo()
      .subscribe(
        success => {
          this.tipos = success.data.tipos;
          this.situacoes = success.data.situacoes;
        },
        error => console.log(error)
      );
  }

  buscarSituacoesETiposAnexoAutorizacaoVinculacao() {
    this.anexarImagensService.buscarSituacoesETiposAnexoAutorizacaoVinculacao(this.situacoesETiposAnexoVO).pipe(
      tap(response => {
        this.tiposAutorizacao = response.data.tipos;
        this.tipoXSituacao = response.data.tipoXSituacao;

        if (this.somenteGuia) {
          this.tiposAutorizacao = [];
          this.tiposAutorizacao.push({
            codigo: '3',
            descricao: 'Guia'
          });

          this.tipoXSituacao['3'] =
            [
              {
                codigo: '2',
                descricao: 'Pagamento'
              }
            ];
        }
      }),
      catchError(error => {
        const errors = error.error.errors;

        if (error.status === 400) {
          if (errors.find(x => x.message === 'Nenhuma situacao permitida.')) {
            this.habilitarAnexarAlterarImagem = false;
            this.attachErrorEmmiter.emit(true);
            this.onlyAttachView = true;
            this.changeButtonAnexarName();
          } else {
            this.anexarImagensService.displayUnknowErrors(error);
          }
        }

        return of(null);
      })
    ).subscribe();
  }

  public show() {
    this.display = true;
    this.anexoCarregado = false;
    this.inputValue = '';
    this.inputName = this.changeInputName();
  }

  public selecionarArquivo() {
    if (this.habilitarAnexarAlterarImagem) {
      this.file.nativeElement.click();
    } else {
      console.log('Não habilitada a seleção de arquivo');
    }
  }

  public onChangeFile() {
    if (this.file.nativeElement.files[0]) {
      this.inputValue = this.file.nativeElement.value;
      this.inputName = this.file.nativeElement.files[0].name;
      this.anexoCarregado = true;
      this.classeBtn = 'bt bt-primary';
    }

  }

  private cleanFile() {
    this.inputValue = '';
    this.inputName = this.changeInputName();
    this.classeBtn = 'bt bt-gray';
    this.anexoCarregado = false;
    this.file.nativeElement.value = null;
    this.uploading = false;
  }

  public incluirAnexo() {
    if (this.anexoCarregado && this.habilitarAnexarAlterarImagem) {
      const file = this.file.nativeElement.files[0];

      this.uploading = true;
      this.novaGtoService.anexarArquivo(file)
        .subscribe(
          success => {

            let codigoSituacao = '0';
            let codigoTipo = '0';

            if (this.somenteGuia) {
              codigoTipo = this.tiposAutorizacao.find(x => x.descricao === 'Guia').codigo;
              codigoSituacao = this.tipoXSituacao[codigoTipo][0].codigo;
            }

            this.listaAnexos.push({
              url: success.data,
              nome: file.name,
              codigoSituacao,
              codigoTipo,
              codigoProcedimento: (this.procedimento != null) ? this.procedimento.codigo : null,
              linhaProcedimento: (this.procedimento != null) ? this.procedimento.linha : null,
              deletable: true,
              isInvalidTipo: false,
              isInvalidSituacao: false
            });

            this.cleanFile();

            this.changeButtonAnexarName();
            this.changeIconAnexar();

            this.messageService.add({ severity: 'success', summary: 'Sucesso no upload', detail: 'O arquivo foi anexado com sucesso!' });
          },
          error => {
            this.cleanFile();
            this.messageService.add({ severity: 'error', summary: 'Falha no upload', detail: error.error.errors[0].message });
          }
        );
    }
  }

  public removerImagem(imagemIndice) {
    this.listaAnexos.splice(imagemIndice, 1);
    this.anexarImagensService.emitAnexosChangeEvent(true);
  }

  private changeInputName() {
    if (this.somenteGuia) {
      if (this.onlyAttachView) {
        return 'Visualizar Guia';
      } else {
        return 'Anexar Guia';
      }
    }

    return INPUT_NAME_MESSAGE;
  }

  private getTipo(t: any) {
    if (this.tipos.length > 0) {
      for (let index = 0; index < this.tipos.length; index++) {
        const element = this.tipos[index].codigo;

        if (element == t) {
          return this.tipos[index].descricao;
        }
      }
    }
  }

  private getSituacao(t: any) {
    if (this.situacoes.length > 0) {
      for (let index = 0; index < this.situacoes.length; index++) {
        const element = this.situacoes[index].codigo;

        if (element == t) {
          return this.situacoes[index].descricao;
        }
      }
    }
  }

  private setTipo(tipo, indice) {
    this.listaAnexos[indice].codigoTipo = tipo.codigo;
    this.listaAnexos[indice].tipo = tipo.descricao;
  }

  private setSituacao(situacao, indice) {
    this.listaAnexos[indice].codigoSituacao = situacao.codigo;
    this.listaAnexos[indice].situacao = situacao.descricao;
  }

  private getBase64(file) {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    const fd = new FormData();

    fd.append('file', file, file.name);
    reader.onload = () => this.listaAnexos.push({ codigoTipo: '1', codigoSituacao: '2', file: fd, src: reader.result, nome: file.name });
    reader.onerror = (err) => console.log('Mensagem de erro' + err);
  }

  changeButtonAnexarName() {
    if (this.somenteGuia) {
      if (this.onlyAttachView) {
        return 'Visualizar Guia';
      } else {
        return 'Anexar Guia';
      }
    }

    if (this.habilitarAnexarAlterarImagem && this.getAnexos().length === 0) {
      return 'Anexar';
    }

    if (this.habilitarAnexarAlterarImagem && this.getAnexos().length > 0) {
      return 'Anexar/Visualizar';
    }

    if (this.habilitarAnexarAlterarImagem === false) {
      return 'Visualizar';
    }

    return 'Anexar';

  }

  changeIconAnexar() {
    if (this.habilitarAnexarAlterarImagem && this.getAnexos().length === 0) {
      return 'assets/images/icons/ic-add-imgs.png';
    }

    if (this.habilitarAnexarAlterarImagem && this.getAnexos().length > 0) {
      return 'assets/images/icons/bt-visualizar-imgs.png';
    }

    if (this.habilitarAnexarAlterarImagem === false && this.getAnexos().length > 0) {
      return 'assets/images/icons/bt-visualizar-imgs.png';
    }

    return 'assets/images/icons/ic-add-imgs.png';

  }

  isUrlDocuware(url): boolean {
    if (url) {
      const index = url.toUpperCase().indexOf('DOCUWARE');

      if (index > -1) {
        return true;
      }
    }
    return false;
  }

  getTipoPlaceholder(codigo) {
    if (codigo > 0) {
      return '';
    } else {
      return 'Tipo';
    }
  }

  getSituacaoPlaceholder(codigo) {
    if (codigo > 0) {
      return '';
    } else {
      return 'Situação';
    }
  }

  onChangeVisible(visible) {
    // Ao fechar a modal, emitir a atual situacao da lista de anexos.

    if (!visible) {
      this.verificaErrosComponente();
      this.anexarImagensService.emitAnexosChangeEvent(true);
    }
  }

  verificaErrosComponente() {
    this.errorAnexos = !this.isValidAnexosIncluidos();
    this.isInvalid.emit(this.errorAnexos);
  }

  setDeletableFalse() {
    if (this.listaAnexos) {
      let i = 0;
      for (i = 0; i < this.listaAnexos.length; i++) {
        this.listaAnexos[i].deletable = false;
      }
    }
  }

  isValidAnexosIncluidos(): boolean {
    const anexos = this.getAnexos();

    if (anexos && anexos.length > 0) {
      for (let i = 0; i < anexos.length; i++) {
        this.validaAnexo(anexos[i]);
        if (anexos[i].isInvalidTipo || anexos[i].isInvalidSituacao) {
          return false;
        }
      }
    }

    return true;
  }

  validaAnexo(anexo) {
    if (anexo && anexo.deletable) {
      this.validaTipo(anexo);
      this.validaSituacao(anexo);
    }
  }

  validaTipo(anexo) {
    if (!this.isValidCodigo(anexo.codigoTipo)) {
      anexo.isInvalidTipo = true;
    } else {
      anexo.isInvalidTipo = false;
    }
  }

  validaSituacao(anexo) {
    if (!this.isValidCodigo(anexo.codigoSituacao)) {
      anexo.isInvalidSituacao = true;
    } else {
      anexo.isInvalidSituacao = false;
    }
  }

  selectTipo(event, anexo) {
    anexo.codigoTipo = event.value;
    this.validaTipo(anexo);

    anexo.displayHintSituacao = false;

    /*Caso ja houver situacao selecionada, ver se ela consta na lista deste tipo*/
    if (!isNullOrUndefined(anexo.codigoSituacao) && anexo.codigoSituacao > 0) {
      let situacaoPermitida = false;
      this.tipoXSituacao[anexo.codigoTipo].forEach(situacao => {
        if (anexo.codigoSituacao == situacao.codigo) {
          situacaoPermitida = true;
        }
      });
      if (!situacaoPermitida) {
        anexo.codigoSituacao = '0';
      }
    }
  }

  getTipoXSituacao(anexo) {
    if (!isNullOrUndefined(anexo.codigoTipo) && anexo.codigoTipo > 0) {
      return this.tipoXSituacao[anexo.codigoTipo];
    }
    return null;
  }

  onClickSituacao(anexo) {
    if (isNullOrUndefined(anexo.codigoTipo) || anexo.codigoTipo === 0) {
      anexo.displayHintSituacao = true;
    }
  }

  selectSituacao(event, anexo) {
    anexo.codigoSituacao = event.value;
    this.validaSituacao(anexo);
  }

  isValidCodigo(codigo): boolean {
    codigo = Number(codigo);
    if (!codigo || codigo <= 0) {
      return false;
    }
    return true;
  }

  isDisplayAnexo(anexo): boolean {
    if (this.procedimento && this.procedimento.linha != anexo.linhaProcedimento) {
      return false;
    }
    return true;
  }

  getAnexos() {
    let list = [];
    if (this.listaAnexos) {
      let i = 0;
      this.listaAnexos.forEach(anexo => {
        anexo.indice = i++;
        if (this.isDisplayAnexo(anexo)) {
          list.push(anexo);
        }
      });
    }

    return list;
  }

  openImgNewWindow(url: string) {
    window.open(url, '', 'width=800,height=600');
  }

  getDocuwareID(url: string) {
    const index = url.toUpperCase().indexOf('DOCUWARE');

    return url.substring(index);
  }

  isFileTYPE(type: string, filename: string) {
    const ext: string = filename.split('.').pop();

    if (!ext) {
      return false;
    }

    if (type == 'DOC') {
      return DOC_EXTENSIONS.includes(ext.toUpperCase());
    } else if (type == 'PDF') {
      return PDF_EXTENSIONS.includes(ext.toUpperCase());
    } else if (type == 'IMG') {
      return IMG_EXTENSIONS.includes(ext.toUpperCase()) || this.isUrlDocuware(filename);
    }

    return false;
  }

  isFileUnknow(filename: string) {
    if (!this.isFileTYPE('DOC', filename)
      && !this.isFileTYPE('PDF', filename)
      && !this.isFileTYPE('IMG', filename)) {
      return true;
    } else {
      return false;
    }
  }

  showVisualizar() {
    if (this.onlyModal) {
      return false;
    }

    return (this.getAnexos() && this.getAnexos().length > 0) || this.habilitarAnexarAlterarImagem;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/anexar-imagens/anexar-imagens.component.ts